import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export type TvsState =
  | 'verification_success'
  | 'verification_landing_page'
  | 'veriff_verification'
  | 'verification_check_veriff'
  | 'verification_failure_veriff'
  | 'webid_verification_check_page'
  | 'verification_webid_tan'
  | 'webid_verification_start'
  | 'verification_failure_webid'
  | '';

export const useTvsState = (): [TvsState | null, (state: TvsState) => void] => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tvsState = searchParams.get('tvs_state') as TvsState | null;

  const setTvsState = (newState: TvsState) => {
    setSearchParams(
      (prevParams) => {
        const newParams = new URLSearchParams(prevParams);
        newParams.set('tvs_state', newState);
        return newParams;
      },
      { replace: true },
    );
  };

  useEffect(() => {
    const handlePopState = () => {
      setSearchParams(new URLSearchParams(window.location.search));
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [setSearchParams]);

  return [tvsState, setTvsState];
};
